import { AddressInterface } from 'common/address.interface';
import { CarInterface } from '../fleet/types';

/*
 * Action Types
 */
export enum GarageTypes {
  LIST_GARAGE_REQUEST = '@garage/LIST_GARAGE_REQUEST',
  LIST_GARAGE_SUCCESS = '@garage/LIST_GARAGE_SUCCESS',
  LIST_GARAGE_FAILURE = '@garage/LIST_GARAGE_FAILURE',

  GET_GARAGE_REQUEST = '@garage/GET_GARAGE_REQUEST',
  GET_GARAGE_SUCCESS = '@garage/GET_GARAGE_SUCCESS',
  GET_GARAGE_FAILURE = '@garage/GET_GARAGE_FAILURE',

  FILTER_GARAGE_REQUEST = '@garage/FILTER_GARAGE_REQUEST',
  FILTER_GARAGE_SUCCESS = '@garage/FILTER_GARAGE_SUCCESS',
  FILTER_GARAGE_FAILURE = '@garage/FILTER_GARAGE_FAILURE',

  CREATE_GARAGE_REQUEST = '@garage/CREATE_GARAGE_REQUEST',
  CREATE_GARAGE_SUCCESS = '@garage/CREATE_GARAGE_SUCCESS',
  CREATE_GARAGE_FAILURE = '@garage/CREATE_GARAGE_FAILURE',

  UPDATE_GARAGE_REQUEST = '@garage/UPDATE_GARAGE_REQUEST',
  UPDATE_GARAGE_SUCCESS = '@garage/UPDATE_GARAGE_SUCCESS',
  UPDATE_GARAGE_FAILURE = '@garage/UPDATE_GARAGE_FAILURE',

  DELETE_GARAGE_REQUEST = '@garage/DELETE_GARAGE_REQUEST',
  DELETE_GARAGE_SUCCESS = '@garage/DELETE_GARAGE_SUCCESS',
  DELETE_GARAGE_FAILURE = '@garage/DELETE_GARAGE_FAILURE',
}

/*
 * Data types
 */
export interface BoundsInterface {
  lat: number;
  lng: number;
}

export interface ServicesInterface {
  id: string;
  garageId: string;
  title: string;
  bounds: BoundsInterface[];
}

export interface QuantityInterface {
  id: string;
  garageId: string;
  type: string;
  value: number;
}

export interface ResponsibleInterface {
  id: string;
  name: string;
  email: string;
}

export interface GarageInterface {
  id: string;
  name: string;
  phone: string;
  cnpj: string;
  address: string;
  bounds: BoundsInterface[];
  createdAt: string;
  updatedAt: string;
  Cars?: CarInterface[];
  Addresses?: AddressInterface[];
  GarageQuantities: QuantityInterface[];
  GarageServices: ServicesInterface[];
  TransportSupervisor: ResponsibleInterface;
}

/*
 * State type
 */
export interface GarageState {
  readonly garageList: GarageInterface[];
  readonly garageData: GarageInterface;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
